import { useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useEffectOnce } from 'react-use';
import box from '~/assets/icons/box_2.svg';
import exit from '~/assets/icons/exit.svg';
import heart from '~/assets/icons/heart.svg';
import plusRound from '~/assets/icons/plus_round.svg';
import { Text } from '~/components/ui/Text';
import { Apps } from '~/shared';
import adsIcon from '../../assets/icons/apps/ads.svg';
import {
	resetSlice,
	returnToLauncher,
	setActiveFilter,
	setActivePage,
	setCategorySelectVisible,
	setItemPageVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { AppAdsCategorySelect } from '../AppAdsCategorySelect';
import { AppAdsCreate } from '../AppAdsCreate';
import { AppAdsDoneScreen } from '../AppAdsDoneScreen';
import { AppAdsItemPage } from '../AppAdsItemPage';
import { AppAdsItemSelect } from '../AppAdsItemSelect';
import { AppAdsItemsPage } from '../AppAdsItemsPage';
import { AppAdsReport } from '../AppAdsReport';
import {
	StyledAddButton,
	StyledAppTitleContainer,
	StyledContainer,
	StyledExitButton,
	StyledFavoriteButton,
	StyledFilterButton,
	StyledItemPageContainer,
	StyledLayoutContainer,
	StyledLeftContainer,
	StyledMenuContainer,
	StyledRightContainer,
	StyledWrapper,
} from '../DefaultAppLayout';
import { LoadingScreen } from '../LoadingScreen';
import { getAppLoadingInfo } from '../TabletApp';
import { AppAdsFilter, appAdsFilterButtons, AppAdsPages } from './AppAds.model';

const AppAds = () => {
	const dispatch = useLayoutDispatch();
	const activeFilter = useLayoutSelector((state) => state.ads.activeFilter);
	const activePage = useLayoutSelector((state) => state.ads.activePage);
	const itemPageVisible = useLayoutSelector(
		(state) => state.ads.itemPageVisible,
	);
	const reportVisible = useLayoutSelector((state) => state.ads.reportVisible);
	const createVisible = useLayoutSelector((state) => state.ads.createVisible);
	const categorySelectVisible = useLayoutSelector(
		(state) => state.ads.categorySelectVisible,
	);
	const itemSelectVisible = useLayoutSelector(
		(state) => state.ads.itemSelectVisible,
	);
	const doneVisible = useLayoutSelector((state) => state.ads.doneVisible);
	const loadingInfo = getAppLoadingInfo(Apps.Ads);
	const [loading, setLoading] = useState(true);

	useEffectOnce(() => {
		setTimeout(() => {
			setLoading(false);
		}, 1000);

		return () => {
			dispatch(resetSlice());
		};
	});

	return (
		<StyledWrapper>
			<SwitchTransition>
				<CSSTransition
					timeout={300}
					key={loading ? 0 : 1}
					classNames={'loading'}
					addEndListener={(node, done) =>
						node.addEventListener('transitionend', done, false)
					}
				>
					{loading ? (
						<LoadingScreen
							icon={loadingInfo.loadingIcon}
							text={loadingInfo.loadingMessage}
							color={loadingInfo.color}
							name={loadingInfo.name}
						/>
					) : (
						<StyledContainer>
							<StyledLayoutContainer $compact={itemPageVisible}>
								<StyledLeftContainer>
									<StyledAppTitleContainer>
										<img src={adsIcon} />
										<div>
											<Text className={'title'}>Объявления</Text>
											<Text className={'text'}>Продай все в один клик</Text>
										</div>
									</StyledAppTitleContainer>
									<StyledMenuContainer style={{ marginTop: 25, flex: 1 }}>
										{Object.values(AppAdsFilter).map((item) => (
											<StyledFilterButton
												$active={
													activeFilter === item &&
													activePage === AppAdsPages.Main
												}
												key={item}
												onClick={() => {
													dispatch(setActiveFilter(item));
													dispatch(setItemPageVisible(false));
													dispatch(setActivePage(AppAdsPages.Main));
												}}
												$color={'#2d70da'}
											>
												<img src={appAdsFilterButtons[item].icon} />
												<Text>{appAdsFilterButtons[item].name}</Text>
											</StyledFilterButton>
										))}
									</StyledMenuContainer>
									<StyledMenuContainer>
										<StyledFilterButton
											$active={activePage === AppAdsPages.MyItems}
											onClick={() =>
												dispatch(setActivePage(AppAdsPages.MyItems))
											}
											$color={'#2d70da'}
										>
											<img src={box} />
											<Text>Мои товары</Text>
										</StyledFilterButton>
										<StyledFavoriteButton
											$active={activePage === AppAdsPages.Favorites}
											onClick={() =>
												dispatch(setActivePage(AppAdsPages.Favorites))
											}
										>
											<img src={heart} />
											<Text>Избранное</Text>
										</StyledFavoriteButton>
										<StyledAddButton
											onClick={() => dispatch(setCategorySelectVisible(true))}
										>
											<img src={plusRound} />
											<Text>Добавить товар</Text>
										</StyledAddButton>
									</StyledMenuContainer>
									<StyledMenuContainer style={{ marginTop: 40 }}>
										<StyledExitButton
											$compact={itemPageVisible}
											onClick={() => dispatch(returnToLauncher())}
										>
											<img src={exit} />
											<Text>Выйти из приложения</Text>
										</StyledExitButton>
									</StyledMenuContainer>
								</StyledLeftContainer>
								<StyledRightContainer>
									<AppAdsItemsPage />
									{itemPageVisible && (
										<StyledItemPageContainer>
											<AppAdsItemPage />
										</StyledItemPageContainer>
									)}
								</StyledRightContainer>
							</StyledLayoutContainer>
							{reportVisible && <AppAdsReport />}
							{categorySelectVisible && <AppAdsCategorySelect />}
							{itemSelectVisible && <AppAdsItemSelect />}
							{createVisible && <AppAdsCreate />}
							{doneVisible && <AppAdsDoneScreen />}
						</StyledContainer>
					)}
				</CSSTransition>
			</SwitchTransition>
		</StyledWrapper>
	);
};

export { AppAds };
